import { AgGridReact } from 'ag-grid-react'; // React Data Grid Component
import { multiRowSelection } from '../agGridRowSelection';
////import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
import { themeQuartz } from 'ag-grid-community'; //import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
import { useParams, useLocation } from "react-router-dom";
import { NavLink} from "react-router-dom";
import React, { useState, useEffect, useRef } from 'react'
import { Flex, Divider, View, Text, Heading, Button, SelectField, TextField} from '@aws-amplify/ui-react';
import { Auth } from 'aws-amplify';
import Loadingmini from '../components/loadingmini';
import DriverNew from './driver_new';
import TableViewSelector from "../components/tableViewSelector";
import { fetchPaginatedAgoList } from '../paginatedAgoFetch';

export default function Renters() {
    let params = useParams();
    const location = useLocation();
    const fetchGenerationRef = useRef(0);
    const inFlightFleetRef = useRef(null);
    const [users, updateUsers] = useState([])
    const [is_loading, updateIsLoading] = React.useState(false);
    const [is_loading_more_entries, updateIsLoadingMoreEntries] = React.useState(true);
    const [isLoadingGrid, updateIsLoadingGrid] = React.useState(false);
    const [displaySideDock, updateDisplaySideDock] = React.useState(false);
    const [selectedObjectId, updateSelectedObjectId] = React.useState(false);
    const [fleet_codes, updateFleetCodes] = React.useState(null);
    const [selected_fleet, updateSelectedFleet] = React.useState([]);
    const [displayAdministrativeFunctions, updateDisplayAdministrativeFunctions] = React.useState(false);
    const [displaySuperAdministrativeFunctions, updateDisplaySuperAdministrativeFunctions] = React.useState(false);
    const [isInsurerUsertype, updateIsInsurerUsertype] = React.useState(false);
    const [tablePivotMode, updateTablePivotMode] = React.useState(false);
    const gridRef = useRef(null);
    const [tableColumns, updateTableColumns] = React.useState([{}]);
    const [WebPageDateRangeLabel, updateWebPageDateRangeLabel] = React.useState("");
    const [loadError, updateLoadError] = React.useState("");

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const fleetsParam = params.get("fleets");
        if (fleetsParam) {
            updateSelectedFleet(fleetsParam.split(","));
        } else {
            updateSelectedFleet([]);
        }
    }, [location.search]);


    async function getJwtToken() {
        let retries = 5;
        let token = null;
        
        while (retries > 0) {
            try {
            const session = await Auth.currentSession();     
            var accessToken = session.getAccessToken()
            token = accessToken.getJwtToken()
            if (token) break; // valid token ready
            } catch (e) {
            // Auth not ready yet
            console.log("Auth not ready, retrying...", e);
            }
            retries--;
            await new Promise(res => setTimeout(res, 500)); // wait 0.5s before retry
        }
        if (!token) throw new Error("Unable to get a valid JWT token from Auth");



        if(accessToken.payload)
        {
            if(accessToken.payload["cognito:groups"])
            {
                if(accessToken.payload["cognito:groups"][0]==='admin')
                {
                    updateDisplayAdministrativeFunctions(true)
                    updateDisplaySuperAdministrativeFunctions(true)
                } else {
                    if(accessToken.payload["cognito:groups"][0]==='support'||accessToken.payload["cognito:groups"][0]==='fleet')
                    {
                        updateDisplayAdministrativeFunctions(true)
                    } else {
                        if(accessToken.payload["cognito:groups"][0]==='insurer')
                        {
                            updateIsInsurerUsertype(true)
                        }
                    }
                }
            }
        }
        return token;
    }

    async function selectObject(val) {
        updateDisplaySideDock(false);
        await updateSelectedObjectId(val);
        updateDisplaySideDock(true);
    }
    
    function failPageLoad(message, generation, fleetKey) {
        if (generation !== fetchGenerationRef.current) return;
        if (inFlightFleetRef.current === fleetKey) {
            inFlightFleetRef.current = null;
        }
        console.error('error loading drivers:', message);
        updateUsers([]);
        updateLoadError(message);
        updateIsLoading(false);
        updateIsLoadingMoreEntries(false);
    }

    async function fetchPageData(tSelectedFleet, { force = false } = {}) {
        var thisFleet = tSelectedFleet ?? selected_fleet[0] ?? "";
        if(!thisFleet)
        {
            thisFleet = ""
        }
        const fleetKey = thisFleet || "__none__";
        if (!force && inFlightFleetRef.current === fleetKey) {
            console.log('skipping duplicate renters fetch for '+fleetKey);
            return;
        }

        const generation = ++fetchGenerationRef.current;
        inFlightFleetRef.current = fleetKey;
        console.log('fetching page data...')
        updateLoadError("");
        try {
            await getJwtToken();
        } catch (e) {
          console.error("Cannot fetch page data: ", e);
          failPageLoad("Unable to get a valid login session. Please sign in again.", generation, fleetKey);
          return;
        }
        updateIsLoading(true)
        updateIsLoadingMoreEntries(true)
        updateUsers([])
        console.log('fleet: '+thisFleet);

        const baseParams = {
            api_endpoint: "api3:staff:drivers",
        };
        if (thisFleet !== "") {
            baseParams.fleet_code = thisFleet;
        }

        const result = await fetchPaginatedAgoList(baseParams, {
            onProgress: (items, meta) => {
                if (generation !== fetchGenerationRef.current) return;
                updateUsers(items);
                if (items.length > 0) {
                    updateIsLoading(false);
                }
                if (meta?.done) {
                    updateIsLoadingMoreEntries(false);
                }
            },
        });
        if (generation !== fetchGenerationRef.current) {
            return;
        }
        if (inFlightFleetRef.current === fleetKey) {
            inFlightFleetRef.current = null;
        }
        if (!result.ok) {
            failPageLoad(result.error, generation, fleetKey);
            return;
        }

        let webPageDateRL = "";
        for (const row of result.items) {
            if (row && row.WebPageDateRangeLabel) {
                webPageDateRL = row.WebPageDateRangeLabel;
                break;
            }
        }
        updateWebPageDateRangeLabel(webPageDateRL);
        updateUsers(result.items);
        console.log('all pages loaded, rows='+result.items.length)
        updateIsLoading(false)
        updateIsLoadingMoreEntries(false)
    }

    const selectedFleetCode = selected_fleet[0] ?? "";
    useEffect(() => {
        if (selectedFleetCode) {
            fetchPageData(selectedFleetCode);
        }
    }, [selectedFleetCode]);

    const filtersReady = !is_loading_more_entries && !is_loading;
    const gridColumnDefs = filtersReady
        ? tableColumns
        : (tableColumns || []).map((col) => ({
            ...col,
            filter: false,
            floatingFilter: false,
          }));
    

    const blankAgg = (params) => {
        const values = params.values?.filter(v => v !== null && v !== undefined);
        if (!values || values.length === 0) return null;
        const uniqueValues = [...new Set(values)];
    
        // If exactly one unique value, show it
        if (uniqueValues.length === 1) {
            return uniqueValues[0];
        }
    
        // Otherwise, show count
        //const count = values.length;
        //return `${count} value${count === 1 ? "" : "s"}`;
        return null;
    };
    
    

    return(
        <Flex   //  https://ui.docs.amplify.aws/react/components/flex#demo
            direction='column'      //direction={{ base: 'column', large: 'row' }}
            //justifyContent='normal'           justifyContent={{ base: 'flex-start', large: 'flex-start' }}        //justifyContent="center"
            //alignItems='stretch'              alignItems={{ base: 'stretch', large: 'flex-start' }}       //alignItems="center" // alignItems="flex-end" (right)
            //alignContent='normal'             alignContent="flex-start"       //alignContent="center"
            wrap="wrap" //nowrap
            gap="1rem"
        >
            <View style={{padding:"1rem"}}>
                <Flex
                    direction='column'
                >
                    <Heading level={1}>Renters</Heading>
                    <Text>The renters associated with your fleet, even if they haven't rented yet. {WebPageDateRangeLabel !== "" ? WebPageDateRangeLabel : "All metrics are for the most recent 7-day period."}</Text>
                    <View>
                        <Button onClick={() => fetchPageData(undefined, { force: true })}>
                            PRESS TO GET LATEST UPDATES
                        </Button>
                    </View>
                    <Divider />
                    {loadError ? (
                        <Text color="red">{loadError}</Text>
                    ) : (
                        is_loading_more_entries ? <Text><i>Some data is still loading{users.length ? ` (${users.length} so far)` : ''}... Filters unlock when complete.</i></Text> : <Text><i>Hint: To search, long-click on mobile or click top-right on pc.</i></Text>
                    )}
                    {loadError ? null :
                    is_loading ? <Loadingmini /> : 
                    !selected_fleet ? <Loadingmini /> :
                    selected_fleet == "" ? <Loadingmini /> :
                        <Flex direction="column">
                            <Flex wrap="wrap" gap="2rem" >
                                <Flex direction="column" style={{ width: displaySideDock ? '25vw' : '80vw', minWidth: '450px', maxWidth: '2200px' }}>
                                    <Divider />
                                    {
                                        (displayAdministrativeFunctions || isInsurerUsertype) ?
                                        isLoadingGrid ? <Loadingmini /> :
                                        <TableViewSelector 
                                            fetchPageData={() => fetchPageData(undefined, { force: true })} 
                                            tableType="drivers" 
                                            gridRef={gridRef} 
                                            updateTableColumns={updateTableColumns} 
                                            updateTablePivotMode={updateTablePivotMode} 
                                            displaySideDock={displaySideDock} 
                                            selectObject={selectObject} 
                                            selectedFleets={selected_fleet[0] ?? ""}
                                            configReady={filtersReady}
                                        />
                                        : undefined
                                    }
                                    <View 
                                        theme={themeQuartz} //className="ag-theme-quartz" // applying the grid theme
                                        style={{ height: 750 }} // the grid will fill the size of the parent container
                                    >
                                        <AgGridReact
                                            ref={gridRef}
                                            onGridReady={params => {
                                                console.log('onGridReady');
                                                updateIsLoadingGrid(false);
                                            }}
                                            rowData={users}
                                            columnDefs={gridColumnDefs}
                                            aggFuncs={{
                                                blankAgg: blankAgg
                                            }}
                                            defaultColDef={{
                                                enableRowGroup: true,
                                                sortable: true,
                                                filter: filtersReady,
                                                floatingFilter: false,
                                                autoHeaderHeight: true,
                                                wrapHeaderText: true,
                                                aggFunc: 'blankAgg'
                                            }}
                                            rowSelection={multiRowSelection}
                                            pagination={true}
                                            paginationPageSize={25}
                                            paginationPageSizeSelector={[10, 25, 50]}
                                            rowBuffer={5}
                                            enableCellTextSelection={true}
                                            suppressRowVirtualisation={false}
                                            pivotMode={tablePivotMode} 
                                            suppressAggFuncInHeader={true}
                                            sideBar={{
                                                toolPanels: [
                                                  {
                                                    id: "columns",
                                                    labelDefault: "Columns",
                                                    labelKey: "columns",
                                                    toolPanel: "agColumnsToolPanel",
                                                  },
                                                ],
                                                defaultToolPanel: null, // THIS keeps it closed on load
                                              }}
                                            //pivotPanelShow={"always"}
                                            grandTotalRow={"bottom"}
                                        />
                                    </View>
                                    <Divider />
                                </Flex>
                                {
                                    displaySideDock === false ? 
                                    <Flex direction="column">
                                        <Divider />
                                        <Button onClick={() => updateDisplaySideDock(true)}>
                                            ACTIVATE SIDE DOCK
                                        </Button>
                                        <Divider />
                                    </Flex> 
                                    :
                                    selectedObjectId===false || selectedObjectId < 1 ? <Text><i>Please select a user by clicking their user ID in the table...</i></Text> :
                                    <Flex direction="column" style={{width:"55vw"}}>
                                        <Divider />
                                        <Heading level={2}>Driver Details</Heading>
                                        <Text><Button style={{border:'none', fontStyle: 'italic', marginLeft:'-15px'}} onClick={() => updateDisplaySideDock(false)}>To open renters in full-screen mode, click here to hide the side dock.</Button></Text>
                                        <DriverNew userId={selectedObjectId} fleetCode={selected_fleet[0]}/>
                                        <Divider />
                                    </Flex>
                                }
                            </Flex>
                        </Flex>
                    }
                </Flex>
            </View>
        </Flex> 
    );
}
